<ion-content class="garment-listing">
    <app-header [isParentPage]="false" [title]="'Garment Return Review'"></app-header>
    <div class="loading-container" style="padding-top:15%;" *ngIf="!loaded">
        <ion-spinner></ion-spinner>
    </div>
    <ng-container>
        <ion-grid>
             <ion-row class="filter-row">
                <ion-grid>
                  <ion-row class="ion-align-items-center">
                        <ion-col size="12" size-md="3">
                            <span style="color:white">
                                Input a few letters of the last name.
                            </span>
                        </ion-col>

                        <ion-col size="12" size-md="5">
                            <ion-input 
                            type="text"
                            [(ngModel)]="lastName"
                            class="ion-text-left color-light"
                            placeholder="Leave blank for a list of all."
                            (keydown.enter)="onEnterKey($event)">
                            </ion-input>
                        </ion-col>

                        <ion-col size="12" size-md="4">
                            <ion-button 
                            color="gallaghergreen"
                            class="btn-box-shadow"
                            (click)="getDataByLastName()">
                            Show
                            </ion-button>
                        </ion-col>
                        </ion-row>
                </ion-grid>
            </ion-row>

            <ion-row class="table-row">
                <div  #scrollContainer  class="ion-padding table-container" >
                    <app-garment-return-review-table [mode]="'gl'" (paging)="setPage($event)" [pageSize]="pageSize" [pageNumber]="currPage" [rows]="rows" [currentRoute]="currentRoute" [totalElements]="totalElements" [scrollbarV]="true" (stopCodeClicked)="onStopCodeFilter($event)"
                     [pageType]="!authService.user?.isCostCenterUser ? 'garmentListing' : ''" ></app-garment-return-review-table>
                </div>
            </ion-row>
        </ion-grid>
    </ng-container>
</ion-content>
